const SUPPORTED_LANGUAGES = ['en', 'de', 'nl', 'fr'];
export { SUPPORTED_LANGUAGES };
